import { Routes } from "@angular/router";
import { LoginComponent } from "./auth/login";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";
import { HasRoleGuard } from "./shared/guards/has-role.guard";
import { BlogsComponent } from "./components/blogs/blogs.component";
import { Error404Component } from "./shared/components/error404/error404";
import { BillingComponent } from "./components/bill/billing-page.component";
import { ContractTableComponent } from "./components/contract/contract-table/contract-table.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { StatisticsComponent } from "./components/statistics/statistics.component";
import { BillViewComponent } from "./components/bill/bill-view/bill-view.component";
import { BlogFormComponent } from "./components/blogs/blog-form/blog-form.component";
import { UserSettingsComponent } from "./components/user-profile/user-profile.component";
import { TierManagmentComponent } from "./components/tier-managment/tier-managment.component";
import { ContractEditComponent } from "./components/contract/contract-edit/contract-edit.component";
import { UsersTableComponent } from "./components/users/users.table/users.table.component";
import { UserRoles } from "./shared/enums/user-roles";
import { QnAListComponent } from "./components/qna/qna-list/qna-list.component";
import { InstanceRequestsTable } from "./components/instance-requests/instance-requests.table/instance-requests.table.component";
import { TestemonialsTableComponent } from "./components/testemonials/testemonials.table/testemonials.table.component";
import { TestemonailFormComponent } from "./components/testemonials/testemonials.form/testemonials.form.component";

export const routes: Routes = [
  {
    path: "auth",
    component: AuthLayout,
    children: [{ path: "login", component: LoginComponent }],
  },
  {
    path: "",
    component: AppLayout,
    data: { breadcrumb: "breadcrumbs.home" },
    children: [
      {
        path: "",
        component: DashboardComponent,
        title: "Sales Admin | ZEPHYR ",
        canActivate: [HasRoleGuard],
        data: {
          role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight],
          breadcrumb: "breadcrumbs.dashboard",
        },
      },
      {
        path: "billing",
        component: BillingComponent,
        canActivate: [HasRoleGuard],
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.billing" },
      },
      {
        path: "users",
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.users" },
        canActivate: [HasRoleGuard],
        children: [
          { path: "", component: ContractTableComponent },
          { path: ":id", component: ContractEditComponent, data: { breadcrumb: "breadcrumbs.contract_edit" } },
        ],
      },
      {
        path: "instance-requests",
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.requests" },
        canActivate: [HasRoleGuard],
        children: [
          { path: "", component: InstanceRequestsTable },
        ],
      },
      {
        path: "blogs",
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.blogs" },
        canActivate: [HasRoleGuard],
        children: [
          { path: "", component: BlogsComponent },
          { path: "form", component: BlogFormComponent, data: { breadcrumb: "breadcrumbs.blog_create" } },
          { path: "form/:id", component: BlogFormComponent, data: { breadcrumb: "breadcrumbs.blog_edit" } },
        ],
      },
      {
        path: "testemonials",
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "testemonial.title" },
        canActivate: [HasRoleGuard],
        children: [
          { path: "", component: TestemonialsTableComponent },
          { path: "form", component: TestemonailFormComponent, data: { breadcrumb: "testemonial.create" } },
          { path: "form/:id", component: TestemonailFormComponent, data: { breadcrumb: "testemonial.edit" } },
        ],
      },
      {
        path: "statistics",
        component: StatisticsComponent,
        canActivate: [HasRoleGuard],
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.statistics" },
      },
      {
        path: "tier-managment",
        component: TierManagmentComponent,
        canActivate: [HasRoleGuard],
        data: {
          role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight],
          breadcrumb: "breadcrumbs.tier_managment",
        },
      },
      {
        path: "admins",
        component: UsersTableComponent,
        canActivate: [HasRoleGuard],
        data: {
          role: [UserRoles.SuperAdmin],
          breadcrumb: "breadcrumbs.admins",
        },
      },
      {
        path: "questions",
        component: QnAListComponent,
        data: {
          breadcrumb: "breadcrumbs.qna",
        },
      },
      {
        path: "404",
        component: Error404Component,
        canActivate: [HasRoleGuard],
        data: {
          role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight],
          breadcrumb: "breadcrumbs.error_404",
        },
      },
      {
        path: "profile",
        component: UserSettingsComponent,
        canActivate: [HasRoleGuard],
        data: {
          role: [UserRoles.SuperAdminLight, UserRoles.SuperAdmin],
          breadcrumb: "breadcrumbs.profile",
        },
      },
      {
        path: "bill-preview/:contractId/:id",
        component: BillViewComponent,
        canActivate: [HasRoleGuard],
        data: { role: [UserRoles.SuperAdmin, UserRoles.SuperAdminLight], breadcrumb: "breadcrumbs.bill_preview" },
      },
      {
        path: "",
        redirectTo: "/home",
        pathMatch: "full",
      },
      {
        path: "**",
        redirectTo: "/404",
        pathMatch: "full",
      },
    ],
  },
];
